<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formularioValido">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha
                            :items="operadoresOpcoes"
                            :selected-items.sync="operadoresSelecionados"
                            text="operador"
                            value="operador"
                            :can-toggle-all="true"
                            :label="$t('relConsumoApiExterna.filters.operator')"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha
                            :items="servicosOpcoes"
                            :selected-items.sync="servicosSelecionados"
                            text="servico"
                            value="key"
                            :can-toggle-all="true"
                            :label="$t('relConsumoApiExterna.filters.service')"
                            :disabled="!operadoresSelecionados.length"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker
                            :label="$t('datetime.startDate')"
                            v-model="dti"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtiProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker
                            :label="$t('datetime.finalDate')"
                            v-model="dtf"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtfProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="2" md="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="populaRelatorio"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable
            :key="tableKey"
            item-key="id_servico_externo"
            cod-tabela="RELCONSUMOAPI"
            :headers="headers"
            :items="resumo"
            :loading="loading"
            :default-multi-sort="defaultSort"
            :loading-text="$t('relConsumoApiExterna.loading')"
        >
            <template v-slot:toolbar>
                <CadastroToolbar
                    :title="$t('relConsumoApiExterna.title')"
                    :token="token"
                    :items="resumo"
                    csv-title="relconsumoapi"
                    :csv-headers="headers"
                    :pdf-title="$t('relConsumoApiExterna.title')"
                    :pdf-headers="headers"
                    pdf-filename="relconsumoapi"
                    hide-search
                />
            </template>
            <template v-slot:item.will_refresh_at="{ item }">
                {{ formatRefreshDate(item.will_refresh_at) }}
            </template>
        </MerusDataTable>

        <v-card class="mt-6" style="border-radius: 10px;">
            <v-card-title>
                <span class="headline" style="color: #4a4a4a">{{ $t('relConsumoApiExterna.chartTitle') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container
                    v-if="loading"
                    class="pa-8 text-center"
                >
                    <v-progress-circular indeterminate color="primary" :size="64" :width="8" />
                </v-container>
                <v-container
                    v-else-if="chartHasData"
                    style="border: 1px solid #e0e0e0; border-radius: 8px;"
                    class="pa-2"
                >
                    <ChartLine
                        :chart-options="chartOptions"
                        :chart-data="chartData"
                        :height="120"
                    />
                </v-container>
                <v-container v-else class="pa-4 text-center grey--text">
                    {{ $t('relConsumoApiExterna.chartEmpty') }}
                </v-container>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { Line as ChartLine } from 'vue-chartjs/legacy';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
} from 'chart.js';
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import apiController from '@/utils/apiController';
import { LineColors } from '@/constants';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import DateUtils from '../utils/dateutils.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale);

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar,
        ChartLine,
    },
    data: () => ({
        user: null,
        token: null,
        formularioValido: false,
        catalogo: [],
        operadoresSelecionados: [],
        servicosSelecionados: [],
        resumo: [],
        serie: [],
        dtiConsulta: null,
        dtfConsulta: null,
        loading: false,
        dti: null,
        dtf: null,
        timeProps: { useSeconds: true },
        textFieldProps: { readonly: true },
        dtiProps: { max: null },
        dtfProps: { min: null },
    }),
    computed: {
        tableKey() {
            return `rel-consumo-api-${this.$i18n.locale}`;
        },
        operadoresOpcoes() {
            const set = new Set((this.catalogo || []).map((r) => r.operador_api_externa));
            return Array.from(set)
                .sort()
                .map((operador) => ({ operador }));
        },
        servicosOpcoes() {
            return this.buildServicosItens(this.operadoresSelecionados);
        },
        headers() {
            return [
                { text: this.$t('relConsumoApiExterna.headers.operator'), value: 'operador_api_externa', sortable: true, filtrable: false },
                { text: this.$t('relConsumoApiExterna.headers.service'), value: 'servico_api_externa', sortable: true, filtrable: false },
                { text: this.$t('relConsumoApiExterna.headers.currentMonthUsage'), value: 'quantidade_mes_vigente', sortable: true, filtrable: false },
                { text: this.$t('relConsumoApiExterna.headers.periodUsage'), value: 'quantidade_periodo', sortable: true, filtrable: false },
                { text: this.$t('relConsumoApiExterna.headers.monthlyLimit'), value: 'limite_chamadas', sortable: true, filtrable: false },
                { text: this.$t('relConsumoApiExterna.headers.nextRefresh'), value: 'will_refresh_at', sortable: true, filtrable: false },
            ];
        },
        defaultSort() {
            return [
                { value: 'operador_api_externa', options: { text: this.$t('routs.increasing'), value: 1 } },
            ];
        },
        chartLabels() {
            if (!this.dtiConsulta || !this.dtfConsulta) {
                return [];
            }
            const labels = [];
            const current = new Date(this.dtiConsulta);
            current.setHours(0, 0, 0, 0);
            const end = new Date(this.dtfConsulta);
            end.setHours(0, 0, 0, 0);
            while (current.getTime() <= end.getTime()) {
                labels.push(this.formatDayLabel(current));
                current.setDate(current.getDate() + 1);
            }
            return labels;
        },
        chartDayKeys() {
            if (!this.dtiConsulta || !this.dtfConsulta) {
                return [];
            }
            const keys = [];
            const current = new Date(this.dtiConsulta);
            current.setHours(0, 0, 0, 0);
            const end = new Date(this.dtfConsulta);
            end.setHours(0, 0, 0, 0);
            while (current.getTime() <= end.getTime()) {
                keys.push(this.toDayKey(current));
                current.setDate(current.getDate() + 1);
            }
            return keys;
        },
        chartHasData() {
            return this.chartLabels.length > 0 && this.serie.length > 0;
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: true,
                animation: false,
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                    },
                    title: {
                        display: false,
                    },
                },
                scales: {
                    x: {
                        ticks: {
                            maxRotation: 45,
                            minRotation: 0,
                        },
                    },
                    y: {
                        beginAtZero: true,
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            };
        },
        chartData() {
            const byKey = {};
            for (const row of this.serie) {
                const key = this.serieKey(row.operador_api_externa, row.servico_api_externa);
                if (!byKey[key]) {
                    byKey[key] = {};
                }
                byKey[key][this.normalizeDataRef(row.data_ref)] = Number(row.quantidade) || 0;
            }

            const datasets = [];
            let colorIndex = 0;
            for (const row of this.resumo) {
                const key = this.serieKey(row.operador_api_externa, row.servico_api_externa);
                const label = `${row.operador_api_externa} / ${row.servico_api_externa}`;
                const counts = byKey[key] || {};
                const data = this.chartDayKeys.map((dayKey) => counts[dayKey] || 0);
                const color = LineColors[colorIndex % LineColors.length];
                datasets.push({
                    label,
                    data,
                    borderColor: color,
                    backgroundColor: color,
                    pointRadius: 2,
                    spanGaps: true,
                });
                colorIndex += 1;
            }

            return {
                labels: this.chartLabels,
                datasets,
            };
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        },
        operadoresSelecionados() {
            const valid = new Set(this.servicosOpcoes.map((i) => i.key));
            this.servicosSelecionados = (this.servicosSelecionados || []).filter((k) => valid.has(k));
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
        this.initialize();
    },
    methods: {
        initialize() {
            this.setDefaultPeriod();
            this.carregarCatalogo();
        },
        setDefaultPeriod() {
            const dtf = new Date();
            const dti = new Date();
            dti.setDate(dti.getDate() - 30);
            this.dti = dti;
            this.dtf = dtf;
        },
        aplicarFiltrosGlobais(resumo, serie) {
            let resumoFiltrado = resumo || [];
            let serieFiltrada = serie || [];
            if (this.operadoresSelecionados.length) {
                const ops = new Set(this.operadoresSelecionados);
                resumoFiltrado = resumoFiltrado.filter((r) => ops.has(r.operador_api_externa));
                serieFiltrada = serieFiltrada.filter((r) => ops.has(r.operador_api_externa));
            }
            if (this.servicosSelecionados.length) {
                const keys = new Set(this.servicosSelecionados);
                resumoFiltrado = resumoFiltrado.filter((r) => keys.has(this.serieKey(r.operador_api_externa, r.servico_api_externa)));
                serieFiltrada = serieFiltrada.filter((r) => keys.has(this.serieKey(r.operador_api_externa, r.servico_api_externa)));
            }
            return { resumo: resumoFiltrado, serie: serieFiltrada };
        },
        carregarCatalogo() {
            apiController.request(apiController.endpoints.getallLimitesapiexternas, {
                onSuccess: (response) => {
                    this.catalogo = Array.isArray(response.data) ? response.data : [];
                }
            });
        },
        serieKey(operador, servico) {
            return `${operador}|${servico}`;
        },
        buildServicosItens(operadores) {
            const ops = new Set(operadores || []);
            if (!ops.size) {
                return [];
            }
            return (this.catalogo || [])
                .filter((r) => ops.has(r.operador_api_externa))
                .map((r) => ({
                    key: this.serieKey(r.operador_api_externa, r.servico_api_externa),
                    servico: `${r.operador_api_externa} / ${r.servico_api_externa}`,
                }))
                .sort((a, b) => a.servico.localeCompare(b.servico));
        },
        normalizeDataRef(value) {
            if (!value) {
                return '';
            }
            if (value instanceof Date) {
                return this.toDayKey(value);
            }
            const str = String(value);
            const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (match) {
                return `${match[1]}-${match[2]}-${match[3]}`;
            }
            return this.toDayKey(new Date(str));
        },
        toDayKey(date) {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        },
        formatDayLabel(date) {
            const locale = this.$i18n.locale || 'pt-BR';
            return date.toLocaleDateString(locale, { day: '2-digit', month: '2-digit' });
        },
        formatRefreshDate(value) {
            if (!value) {
                return '';
            }
            const date = value instanceof Date ? value : new Date(value);
            if (Number.isNaN(date.getTime())) {
                return String(value);
            }
            const locale = this.$i18n.locale || 'pt-BR';
            return date.toLocaleString(locale);
        },
        populaRelatorio() {
            if (!this.dti || !this.dtf) {
                return;
            }
            this.loading = true;
            const body = {
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf),
            };
            apiController.request(apiController.endpoints.getRelatorioconsumoapiexternas, {
                data: body,
                onSuccess: (response) => {
                    const data = response.data || {};
                    const filtrado = this.aplicarFiltrosGlobais(data.resumo, data.serie);
                    this.resumo = filtrado.resumo;
                    this.serie = filtrado.serie;
                    this.dtiConsulta = new Date(this.dti);
                    this.dtfConsulta = new Date(this.dtf);
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                }
            });
        },
    },
};
</script>
